import { QueryClient } from '@tanstack/react-query'
import type { WorkflowListParams } from '@/api/workflow/list'
import type { RunLogListRequest } from '@/api/workflowEditor/list'

// 创建 QueryClient 实例
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false, // 窗口获得焦点时不重新获取数据
      retry: 1, // 失败重试次数
      staleTime: 5 * 60 * 1000, // 数据 5 分钟内认为是新鲜的
    },
  },
})

// 定义查询键
export const queryKeys = {
  workflows: {
    all: ['workflows'] as const,
    list: (params?: WorkflowListParams) =>
      params
        ? ([...queryKeys.workflows.all, 'list', params] as const)
        : ([...queryKeys.workflows.all, 'list'] as const),
    detail: (id: string) => [...queryKeys.workflows.all, 'detail', id] as const,
  },
  moss: {
    all: ['moss'] as const,
    workflows: (params?: WorkflowListParams) =>
      params
        ? ([...queryKeys.moss.all, 'workflows', params] as const)
        : ([...queryKeys.moss.all, 'workflows'] as const),
  },
  apps: {
    all: ['apps'] as const,
    list: () => [...queryKeys.apps.all, 'list'] as const,
    detail: (id: string) => [...queryKeys.apps.all, 'detail', id] as const,
  },
  versions: {
    all: ['versions'] as const,
    list: (chainId: number) => [...queryKeys.versions.all, 'list', chainId] as const,
    detail: (versionId: number) => [...queryKeys.versions.all, 'detail', versionId] as const,
    diff: (currentId: number, compareId: number) =>
      [...queryKeys.versions.all, 'diff', currentId, compareId] as const,
  },
  runLogs: {
    all: ['runLogs'] as const,
    list: (params?: RunLogListRequest) =>
      params
        ? ([...queryKeys.runLogs.all, 'list', params] as const)
        : ([...queryKeys.runLogs.all, 'list'] as const),
    detail: (runId: string | number) => [...queryKeys.runLogs.all, 'detail', runId] as const,
  },
  imageChat: {
    all: ['imageChat'] as const,
    models: () => [...queryKeys.imageChat.all, 'models'] as const,
    history: (pageNo: number, pageSize: number) => 
      [...queryKeys.imageChat.all, 'history', pageNo, pageSize] as const,
    generationLog: (logId: string | number) => 
      [...queryKeys.imageChat.all, 'generationLog', logId] as const,
  },
} 
